import { useIndustry } from '@/app/providers/industry-context.js';
import MobileCartBarDefault from './MobileCartBar.default.jsx';
import MobileCartBarGrocery from './MobileCartBar.grocery.jsx';
import MobileCartBarFish from './MobileCartBar.fish.jsx';
import MobileCartBarMeat from './MobileCartBar.meat.jsx';
import MobileCartBarPet from './MobileCartBar.pet.jsx';
import MobileCartBarCoffee from './MobileCartBar.coffee.jsx';

const registry = {
  default: MobileCartBarDefault,
  grocery: MobileCartBarGrocery,
  fish: MobileCartBarFish,
  meat: MobileCartBarMeat,
  pet: MobileCartBarPet,
  coffee: MobileCartBarCoffee,
};

export default function MobileCartBar(props) {
  const { key } = useIndustry();
  const Component = registry[key] ?? registry.default;
  return <Component {...props} />;
}
